<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          :disabled="loading"
          hide-details
          v-model="organization"
          :items="organizations"
          item-value="_id"
          flat
          solo
          :label="$t('user.registration.organization')"
          class="rounded-lg"
          clearable
          :filter="customLocalisedAutoCompleteFilter"
        >
          <template v-slot:selection="{ item }">
            {{ getLocalisedValue(item.name) }}
          </template>

          <template v-slot:item="{ item }">
            <div class="d-flex justify-start">
              {{ getLocalisedValue(item.name) }}
            </div>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "EmployeeProfilesTableFilters",
  data() {
    return {
      organization: null,
      organizations: [],
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    organization() {
      this.$emit("filter", "organization", this.organization);
    },
  },
  apollo: {
    getOrganizations() {
      return {
        query: require("../../../organization-module/api/query/getOrganizations.gql"),
        variables: { limit: 0, skip: 0, filterInput: null },
        result({ data }) {
          if (data?.getOrganizations?.organizations) {
            this.organizations = data.getOrganizations.organizations;
          }
        },
      };
    },
  },
};
</script>
